import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './index.css';

export function Loading({ size = 40, loading, children, hideChildren, style, ...props }) {
    return (
        <div {...props} className={`${styles.root} ${loading ? styles.visible : ''} ${hideChildren ? styles.hideChildren : ''}`} style={Object.assign({}, style || {}, { minHeight: `${size}px` })}>
            <div className={styles.progress}>
                <CircularProgress size={size} />
            </div>
            <div className={styles.children}>
                {children}
            </div>
        </div>
    );
}
